<ul class="layout-tabmenu-nav">
    <li class="sidebar-group">
        <mat-button-toggle-group #ladderViewModeGroup="matButtonToggleGroup" (change)="onViewModeChange($event)"
            [vertical]="true">
            <mat-button-toggle class="dashboardOptionSidebar" value="DESIGN"
                [checked]="viewMode == 'RECORD_MODIFICATION'" matTooltip="Record Audit" matTooltipPosition="right">
                <mat-icon>preview</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </li>
</ul>